import cx from 'classnames';
import type { ChangeEventHandler, ComponentProps, FocusEventHandler, ReactNode } from 'react';
import type { Except } from 'type-fest';
import type { InputFormState } from '../../utils/form';
import { handleNativeInputEvent } from '../../utils/inputHandlers';
import { InputIcon } from '../InputIcon';
import styles from './styles.module.css';

export interface TextAreaProps extends Except<ComponentProps<'textarea'>, 'rows' | 'onChange' | 'onBlur'> {
  state?: InputFormState;
  disabled?: boolean;
  rows?: number;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
}

/** @deprecated use TextArea from kitt-universal instead */
export function TextArea({ state, disabled, onChange, onBlur, rows, ...props }: TextAreaProps): ReactNode {
  return (
    <div className={styles.Container}>
      <textarea
        className={cx(styles.TextArea, {
          [styles.WithDefaultHeight]: !rows,
          [styles.WithIcon]: state,
          [styles.Disabled]: disabled,
        })}
        disabled={disabled}
        rows={rows}
        onChange={handleNativeInputEvent(onChange)}
        onBlur={handleNativeInputEvent(onBlur)}
        {...props}
      />
      <div className={styles.TextAreaShadow} />
      {state && <InputIcon disabled={disabled} icon={state === 'valid' ? 'check' : 'cross'} />}
    </div>
  );
}
